// AddNote.tsx
import { Button } from "@components/shadcn-ui/button";
import { Input } from "@components/shadcn-ui/input";
import {Loader2, Send} from "lucide-react";
import { KeyboardEvent } from "react";

export const AddNote = ({
                            newNote,
                            setNewNote,
                            handlePostNote,
                            isSending,
                        }: {
    newNote: string;
    setNewNote: (note: string) => void;
    handlePostNote: () => void;
    isSending: boolean;
}) => {
    const handleKeyPress = (e: KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter' && !e.shiftKey && !isSending) {
            e.preventDefault();
            handlePostNote();
        }
    };

    return (
        <div className="p-4 border-t border-gray-200 bg-white rounded-b-lg">
            <div className="flex items-center space-x-2">
                <Input
                    className="flex-1 p-2 px-3 border rounded-full focus:outline-none focus:ring-2 focus:ring-blue-400"
                    value={newNote}
                    onChange={(e) => setNewNote(e.target.value)}
                    onKeyPress={handleKeyPress}
                    placeholder="Type your message..."
                    maxLength={500}
                    disabled={isSending}
                />
                <Button
                    onClick={handlePostNote}
                    className="rounded-full p-2 h-10 w-10 flex items-center justify-center"
                    disabled={!newNote.trim() || isSending}
                >
                    {isSending ? (
                        <Loader2 className="h-5 w-5 animate-spin" />
                    ) : (
                        <Send className="h-5 w-5" />
                    )}
                </Button>
            </div>
            {newNote.length > 400 && (
                <div className="text-xs text-gray-500 mt-1 text-right">
                    {500 - newNote.length} characters remaining
                </div>
            )}
        </div>
    );
};
